import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    packages: [],
    loading: false,
    errorMessage: null,

    subscribing: false,
    subscribeErrorMessage: null,

    subscriptions: [],
    subscriptionsLoading: false,
    subscriptionsErrorMessage: null,

    deleting: false,
    deleteErrorMessage: null,
};

const vipSupportSlice = createSlice({
    name: "VipSupport",
    initialState,
    reducers: {
        getVipPackagesRequest(state) {
            state.loading = true;
            state.errorMessage = null;
            // Clear stale data at the start of each fetch so a previous org's packages
            // are never shown after switching organizations.
            state.packages = [];
        },
        getVipPackagesSuccess(state, action) {
            state.loading = false;
            state.packages = action.payload || [];
        },
        getVipPackagesFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
        },

        subscribeVipPackageRequest(state) {
            state.subscribing = true;
            state.subscribeErrorMessage = null;
        },
        subscribeVipPackageSuccess(state, action) {
            state.subscribing = false;
            state.packages = action.payload || [];
        },
        subscribeVipPackageFailure(state, action) {
            state.subscribing = false;
            state.subscribeErrorMessage = action.payload;
        },

        getVipSubscriptionsRequest(state) {
            state.subscriptionsLoading = true;
            state.subscriptionsErrorMessage = null;
            // Clear stale data at the start of each fetch so a previous org's subscriptions
            // are never shown after switching organizations.
            state.subscriptions = [];
        },
        getVipSubscriptionsSuccess(state, action) {
            state.subscriptionsLoading = false;
            state.subscriptions = action.payload || [];
        },
        getVipSubscriptionsFailure(state, action) {
            state.subscriptionsLoading = false;
            state.subscriptionsErrorMessage = action.payload;
        },

        deleteVipSubscriptionRequest(state) {
            state.deleting = true;
            state.deleteErrorMessage = null;
        },
        deleteVipSubscriptionSuccess(state) {
            state.deleting = false;
        },
        deleteVipSubscriptionFailure(state, action) {
            state.deleting = false;
            state.deleteErrorMessage = action.payload;
        },

        resetState() {
            return { ...initialState };
        },
    },
});

export default vipSupportSlice;
